import { defineMessages } from 'react-intl';

const messages = defineMessages({
  orderDate: {
    description: 'advancedSearch.orders.filters.orderDate',
    defaultMessage: 'Order Date',
    id: 'ysTr8m',
  },
});

export default messages;
